import React from 'react'
import "./ProductStatistics.css";
import { useIsMobile } from '../../hooks/useMediaQuery';


const Separator = () => (
    <img src="/images/separator.svg" alt="|" className="stat-separator" />
);

export const ProductStatistics = ({ stats = [] }) => {
  const isMobile = useIsMobile();
    if (!isMobile) {
        return (
            <div className="statistics-container">
                <div className="statistics-row top-row">
                    {stats.slice(0, 4).map((stat, idx) => (
                        <React.Fragment key={stat.value + idx}>
                            <div className="stat-item top-stat">
                                <span className="stat-value">{stat.value}</span>
                                <span className="stat-description">{stat.description}</span>
                            </div>
                            {idx < 3 && <Separator />}
                        </React.Fragment>
                    ))}
                </div>
                <div className="statistics-row bottom-row">
                    {stats.slice(4).map((stat, idx) => (
                        <React.Fragment key={stat.value + idx}>
                            <div className="stat-item bottom-stat">
                                <span className="stat-value">{stat.value}</span>
                                <span className="stat-description">{stat.description}</span>
                            </div>
                            {idx < 2 && <Separator />}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            <div className="statistics-container">
                {stats.slice(0, 6).map((item, index) => (
                    <div key={index} className="stats-card half-width">
                        <span className="stat-value">{item.value}</span>
                        <span className="stat-description">{item.description}</span>
                    </div>
                ))}
                {/* Optional 7th stat. Healthcare and Manufacturing pass only 6;
                    reading stats[6] unguarded crashed both pages on phones. */}
                {stats[6] && (
                    <div className="stats-card full-width">
                        <span className="stat-value">{stats[6].value}</span>
                        <span className="stat-description">{stats[6].description}</span>
                    </div>
                )}
            </div>

        );
    }
};

